import {PUBLIC_PRODUCT_FILTER_CONFIG} from '@/submodule/decorate_manage/components/unit_edit_config_public.js'

const config = {
	banner: [{
		tab: '内容设置',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '2400,570',
				code: 'img_url'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}, {
		tab: '其他设置',
		content: [{
			label: '展示方式',
			type: 'radio',
			code: 'show_type',
			options: [{
				name: '顺序展示',
				value: 1
			}, {
				name: '随机展示',
				value: 2
			}]
		}, {
			label: '自动切换时间',
			type: 'select',
			code: 'switch_interval',
			options: [{
				name: '3秒',
				value: 3
			}, {
				name: '5秒',
				value: 5
			}, {
				name: '7秒',
				value: 7
			}]
		}]
	}],
	
	activity: [{
		tab: '服务设置',
		content: PUBLIC_PRODUCT_FILTER_CONFIG()
	}, {
		tab: '其它设置',
		content: [{
			label: '标题',
			type: 'input',
			code: 'title'
		}]
	}],
	
	img_advert: [{
		tab: '左侧广告',
		content: [{
			type: 'list',
			code: 'adverts',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '630,800',
				code: 'img_url'
			}, {
				label: '链接',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}, {
		tab: '右侧频道',
		content: [{
			type: 'list',
			code: 'channels',
			length: 4,
			content: [{
				label: '标题',
				type: 'input',
				code: 'title'
			}, {
				label: '副标题',
				type: 'input',
				code: 'sub_title'
			}, {
				label: '图片1地址',
				type: 'image',
				size: '240,240',
				code: 'img1_url'
			}, {
				label: '图片1链接',
				type: 'link',
				code: 'img1_link_url'
			}, {
				label: '图片2地址',
				type: 'image',
				size: '240,240',
				code: 'img2_url'
			}, {
				label: '图片2链接',
				type: 'link',
				code: 'img2_link_url'
			}]
		}]
	}],
	
	update: [{
		tab: '服务设置',
		content: PUBLIC_PRODUCT_FILTER_CONFIG()
	}, {
		tab: '其它设置',
		content: [{
			label: '标题',
			type: 'input',
			code: 'title'
		}, {
			label: '查看更多链接',
			type: 'link',
			code: 'link_url'
		}]
	}],
	
	waterfall_flow: [{
		tab: '系统推荐',
		content: [{
			label: '标签名称',
			type: 'input',
			code: 'tab_name'
		}, {
			label: '是否显示',
			type: 'radio',
			code: 'show',
			options: [{
				name: '显示',
				value: '1'
			}, {
				name: '不显示',
				value: '0'
			}]
		}, {
			label: '服务数量',
			type: 'input',
			code: 'total'
		}]
	}, {
		tab: '自定义标签',
		content: [{
			type: 'list',
			code: 'tabs',
			length: 4,
			content: [{
				label: '标签名称',
				type: 'input',
				code: 'tab_name'
			}].concat(PUBLIC_PRODUCT_FILTER_CONFIG()).concat([{
				label: '服务数量',
				type: 'input',
				code: 'total'
			}])
		}]
	}],
	
	channel_banner: [{
		tab: '内容设置',
		tips: '注：所有图片的尺寸需保持一致。',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '2400,0',
				code: 'img_url',
				widthParam: 'img_width',
				heightParam: 'img_height'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}],
	
	channel_image_list: [{
		tab: '内容设置',
		content: [{
			type: 'list',
			code: 'list',
			content: [{
				label: '图片地址',
				type: 'image',
				size: '1920,0',
				code: 'img_url',
				widthParam: 'img_width',
				heightParam: 'img_height'
			}, {
				label: '链接地址',
				type: 'link',
				code: 'link_url'
			}]
		}]
	}],
	
	channel_product: [{
		tab: '内容设置',
		content: PUBLIC_PRODUCT_FILTER_CONFIG()
	}, {
		tab: '其它设置',
		content: [{
			label: '样式',
			type: 'thumb',
			code: 'style',
			options: [{
				value: 'channel_product_col5_1',
				image: require('@/submodule/assets/image/decorate/thumb/pc_channel_product_col5_1.jpg')
			}, {
				value: 'channel_product_col5_2',
				image: require('@/submodule/assets/image/decorate/thumb/pc_channel_product_col5_2.jpg')
			}, {
				value: 'channel_product_col4_1',
				image: require('@/submodule/assets/image/decorate/thumb/pc_channel_product_col4_1.jpg')
			}, {
				value: 'channel_product_col2_1',
				image: require('@/submodule/assets/image/decorate/thumb/pc_channel_product_col2_1.jpg')
			}]
		}]
	}]
}

export default config;